<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
					<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
					</div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Tambah Jasa Eksternal</h2>

								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label>
												Pilih Jasa Eksternal<span
													style="color: red;"
													>*</span
												>
											</label>

											<Multiselect
												:options="sparepartList.map(x => x.id)"
												:custom-label="opt => sparepartList.find(x => x.id == opt).name"
												v-model="selected.sparepart_id"
												:disabled="showAddTPJForm"
											/>
											<button class="btn btn-primary mt-3" @click="showAddTPJForm = true">Tambah Jasa Baru</button>
										</div>
									</div>
								</div>
								<template v-if="showAddTPJForm">
									<div class="row row-space">
										<div class="col-12">
											<div class="input-group">
												<label class="label"
													>Nama Jasa<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="name"
													v-model="form.name"
													placeholder="Ketik Nama Sparepart"
												/>
											</div>
										</div>
									</div>

									<div class="row row-space">
										<div
											class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
										>
											<div class="input-group">
												<label class="label"
													>Alias Nama Jasa<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													:disabled="sameAlias"
													class="input--style-4"
													type="text"
													name="name"
													v-model="form.alias"
													placeholder="Ketik Alias Nama Sparepart"
												/>
											</div>
										</div>
									</div>
									<div class="row row-space">
										<div
											class="form-check form-check-inline col-12"
										>
											<input
												class="form-check-input"
												style="width:15%"
												type="checkbox"
												id="inlineCheckbox1"
												value="option1"
												v-model="sameAlias"
											/>
											<label
												class="form-check-label"
												for="inlineCheckbox1"
												>Sama Dengan Nama Sparepart</label
											>
										</div>
									</div>
								</template>

								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label>
												Pilih Nomor Work Order<span
													style="color: red;"
													>*</span
												>
											</label>

											<Multiselect
												:options="workOrderList.map(x => x.form_code)"
												:custom-label="opt => workOrderList.find(x => x.form_code == opt).name"
												v-model="formTPJ.work_order_code"
											/>
										</div>
									</div>
								</div>

								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label>
												Harga Jasa<span
													style="color: red;"
													>*</span
												>
											</label>

											<input
												class="input--style-4"
												type="text"
												name="name"
												v-model="formTPJ.amount"
												placeholder="Ketik Harga Jasa"
											/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label>
												Tanggal Pengerjaan<span
													style="color: red;"
													>*</span
												>
											</label>

											<flat-pickr
												v-model="formTPJ.tgl_pengerjaan"
												:config="rangeConfig"
												placeholder="Pilih Tanggal"
											></flat-pickr>
										</div>
									</div>
								</div>					

								<div class="row">
									<div
										class="col mt-5"
										style="text-align: center"
									>
										<button
											type="button"
											class="btn btn-danger"
											style="font-size:140%"
											@click="$emit('closeModal')"
										>
											Kembali
										</button>
										<button
											type="button"
											class=" ml-3 btn btn-primary"
											style="font-size:140%"
											@click="submitForm()"
										>
											Submit
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import Multiselect from "vue-multiselect";
import FormData from "form-data";

export default {
	data() {
		return {
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
			},
			form: {
				name: "",
				alias: "",
				sparepart_type_id: 5,
				amount: 0,
			},

			formTPJ : {
				sparepart_id : null,
				amount : 0,
				sparepart_name : null,
				tgl_pengerjaan : null,
				work_order_code : null
			},
			sparepartList : [],
			workOrderList : [],
			selected : {
				sparepart_id : null
			},

			sameAlias: false,
			showAddTPJForm : false,
			sparepartType: [
				{
					name: "Jasa",
					variable: 1,
				},
				{
					name: "Part",
					variable: 2,
				},
				{
					name: "Bahan",
					variable: 3,
				},
				{
					name: "Lainnya",
					variable: 4,
				},
			],
		};
	},
	components: {
		Multiselect,
	},
	props: [],
	mounted () {
		this.getSparepartVariantsTPJ()
		this.loadWorkOrder()
		
	},
	watch : {
		'selected.sparepart_id' : function () {
			this.searchSparepartID(this['selected'].sparepart_id)
		},
		'formTPJ.amount' : function () {
			let result = this.formTPJ.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.formTPJ.amount = result);
		}
	},
	methods: {
		loadWorkOrder () {
			this.$http.get('/api/v1/masterData/workorder?pagination=false&order=DESC&by=created_at')
			.then((resp) => {
				this.workOrderList = resp.data.data

				for(var i = 0 ; i < this.workOrderList.length; i++) {
					this.workOrderList[i].name = this.workOrderList[i].form_code + ' - ' + this.workOrderList[i].no_polisi + ' - ' + this.workOrderList[i].car_name
				}
				// console.log(this.woList)
			})
			.catch((err) => { console.log(err) })

		},
		getSparepartVariantsTPJ() {
			this.$http.get('/api/v1/masterData/sparepart/variants?sparepart_type_id=5&pagination=false')
			.then((resp) => {
				this.sparepartList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert', [false, [err]]);
			})
		},
		searchSparepartID (sparepart) {
			let url = `/api/v1/masterData/sparepart`

			this.$http.get(url + `?variant_id=${sparepart}`)
			.then((resp) => {
				let data = resp.data.data[0]
				this.formTPJ.sparepart_id = data.id
			})
			.catch((err) => {
				console.log(err)
			})
	
		},
		async submitForm () {
			if(!this.formTPJ.sparepart_id) {
				let returnData = await this.submitSparepart()
				// if(this.formTPJ.sparepart_id)
				if(!returnData)
					return
				else {
					this.formTPJ.sparepart_id = returnData
					this.formTPJ.sparepart_name = this.form.name
				}
			}
			else {
				this.formTPJ.sparepart_name = this.sparepartList.find(x => x.id == this.selected.sparepart_id).name
			}

			this.$emit('addSparepartToTable' , this.formTPJ)
			this.$emit('closeModal')

		},
		async submitSparepart() {

			try {
				if (this.sameAlias) {
					this.form.alias = this.form.name;
				}

				if (!this.validate()) {
					this.$store.dispatch("triggerAlert", [
						false,
						["Tolong isi semua data di formulir ini."],
					]);
					// console.log(this.validate());
					return;
				}

				let resp = await this.$http
					.post("/api/v1/masterData/sparepart/variants", this.form)
				
				console.log(resp.data.data)
				return resp.data.data.id
			}
			catch(err) {
				console.log(err);
				this.$store.dispatch("triggerAlert", [false, [err]]);
				return false
			}
			
		},
		validate() {
			let valid = true;
			if (this.form.name == "" || !this.form.name) valid = false;

			if (this.form.alias == "" || !this.form.alias) valid = false;

			return valid;
		},
	},
};
</script>

<style>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.input--style-4:disabled {
	background-color: #444;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

/* FILE DRAG N' DROP START */
.dropZone {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone:hover {
	border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
	color: #1975a0;
}

.dropZone-info {
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.dropZone-title {
	color: #787878;
}

.dropZone input {
	position: absolute;
	cursor: pointer;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.dropZone-upload-limit-info {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.dropZone-over {
	background: #5c5c5c;
	opacity: 0.8;
}

.dropZone-uploaded {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone-uploaded-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.removeFile {
	width: 200px;
}
/* FILE DRAG N' DROP END */
</style>
